import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright 2017-2021 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values
export var TextDecoder =
/*#__PURE__*/
function () {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-useless-constructor
  function TextDecoder(_) {// nothing

    _classCallCheck(this, TextDecoder);
  }

  _createClass(TextDecoder, [{
    key: "decode",
    value: function decode(value) {
      return value.reduce(function (str, code) {
        return str + String.fromCharCode(code);
      }, '');
    }
  }]);

  return TextDecoder;
}();